module.exports = __webpack_public_path__ + "static/media/oxygen-tank.45459143.svg";